// Vendor libraries
import { createAction, props } from '@ngrx/store';
export const setConversation = createAction('[AI Chat Page] Set AI Chat Conversation', props());
export const addMessage = createAction('[AI Chat Page] Add Message', props());
export const updateAIReplyMessage = createAction('[AI Chat Page] Update AI Message', props());
export const addMessageIds = createAction('[AI Chat Page] Add Message IDs', props());
